// Copyright (c) 2017 Deere & Company

import * as pipSearchHelper from '../../shared/services/pip-search-helper';
import React, {PropTypes} from 'react';
import {
    injectIntl,
    intlShape
} from 'react-intl';
import SearchBox from '../../../shared/components/search-box';
import SearchDropDown from '../../shared/state/search-by-dropdown';

const handleSearch = props => query => {

    if (!pipSearchHelper.mapPipValidation(props.searchByDropDown.selectedOption.key, query)) {

        pipSearchHelper.showValidationError(
            props.intl.formatMessage,
            pipSearchHelper.mapValidationErrorMessages(props.searchByDropDown.selectedOption.key)
        );

        return;

    }

    props.actions.updateSearchResults(query, props.searchByDropDown.selectedOption.key);

};

const PipSearchBox = props =>
    <SearchBox
        defaultOption={props.searchByDropDown.selectedOption.key}
        onOptionChange={props.actions.updateSearchDropDown}
        onQueryChange={props.actions.updateSearchQueryString}
        onSearch={handleSearch(props)}
        placeholderText={pipSearchHelper.mapSearchPlaceHolder(props.searchByDropDown.selectedOption.key)}
        queryString={props.searchQueryString}
        searchBy={props.searchByDropDown.searchBy}
    />;

PipSearchBox.displayName = 'PipSearchBox';
PipSearchBox.propTypes = {
    actions: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
    searchByDropDown: PropTypes.instanceOf(SearchDropDown).isRequired,
    searchQueryString: PropTypes.string.isRequired
};

export default injectIntl(PipSearchBox);



// WEBPACK FOOTER //
// ./src/pip/shared/components/pip-search-box.js